import React, { useMemo } from 'react'

import TextareaWithVariables from '../../../../../gd-components/textarea-with-variables/textarea-with-variables'
import FormManager from '../../../../../gd-form/common/form-manager'
import {buildFormulaTokens} from './formula-tokens'

type Props = {
    className?  : string

    form        : FormManager
}

export default function FormulaEditPopoverForm(props: Props) {

    const tokens = useMemo(()=>{
        return buildFormulaTokens()
    }, [])

    const onChange = (text: string) => {
        props.form.onFormComponentValueChange('formula', text)
        return
    }

    return (
        <TextareaWithVariables
            className   = {props.className}
            value       = {props.form.getValue('formula') || ''}
            onChange    = {onChange}
            tokens      = {tokens}
            rows        = {4}
        />
    )
}
